import { Attribution, AttributionLink } from '@99designs/emu';
import { FormattedReactMessage, formatMessage } from '@99designs/frontend-components/i18n';

interface CustomerAttributionProps {
    displayName: string;
    link?: string;
}

export function ContestCustomerAttribution({ displayName, link }: CustomerAttributionProps) {
    if (link) {
        return (
            <Attribution>
                <FormattedReactMessage
                    message={__('Design contest for <CustomerLink>{displayName}</CustomerLink>')}
                    values={{ displayName }}
                    replacements={{
                        CustomerLink: (
                            <AttributionLink href={link} aria-label={__('See design contest')} />
                        ),
                    }}
                />
            </Attribution>
        );
    }

    return (
        <Attribution>
            {formatMessage(__('Design contest for {displayName}'), {
                displayName,
            })}
        </Attribution>
    );
}

export function CustomerAttribution({ displayName, link }: CustomerAttributionProps) {
    if (link) {
        return (
            <Attribution>
                <FormattedReactMessage
                    message={__('Design for <CustomerLink>{displayName}</CustomerLink>')}
                    values={{ displayName }}
                    replacements={{
                        CustomerLink: (
                            <AttributionLink
                                href={link}
                                aria-label={__('Profile for {displayName}')}
                            />
                        ),
                    }}
                />
            </Attribution>
        );
    }

    return (
        <Attribution>
            {formatMessage(__('Design for {displayName}'), {
                displayName,
            })}
        </Attribution>
    );
}
